import { KpiData } from '@/dashboards/CompetitorsMediaInvestment/types';

export const formatKpiData = (kpiData: KpiData): { [key: string]: number } => {
    const data = {};
    kpiData.forEach((kpi) => {
        data[kpi.period] = kpi.kpi;
    });

    return data;
};
